import React, {ReactNode} from 'react'
const TooltipCommon = ({
  text,
  coverClassName,
  children,
}: {
  text: string
  coverClassName: string
  children: ReactNode
}) => {
  //test
  const [hovered, setHovered] = React.useState(false)
  return (
    <>
      <div
        className={`tooltip-cover position-relative ${coverClassName}`}
        onMouseEnter={(e) => {
          e.preventDefault()
          setHovered(true)
        }}
        onMouseLeave={(e) => {
          e.preventDefault()
          setHovered(false)
        }}
      >
        {children}
        <div
          className={`position-absolute bg-f4f4f4 card tooltip-card px-2 py-3 min-w-300px ${
            hovered ? 'd-block' : 'd-none'
          }`}
          style={{top: '110%', border: '1px solid #000', zIndex: '99999'}}
        >
          <p className='m-0'>{text}</p>
        </div>
      </div>
    </>
  )
}
export default TooltipCommon
